import { render, staticRenderFns } from "./data-abstract.vue?vue&type=template&id=c85eef24&scoped=true"
import script from "./data-abstract.vue?vue&type=script&lang=js"
export * from "./data-abstract.vue?vue&type=script&lang=js"
import style0 from "./data-abstract.vue?vue&type=style&index=0&id=c85eef24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85eef24",
  null
  
)

export default component.exports